// extracted by mini-css-extract-plugin
export var content = "_nq-1";
export var fullScreen = "_nq-0";